export enum ToastMessageType {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}
